import api from '../api/api';
import type { AccessMatrix } from '../utils/jwtUtils';

/**
 * Fetch user permissions from the API endpoint.
 * This replaces reading permissions from the JWT token to avoid 431 header too large errors.
 *
 * Endpoint: GET /core/api/v1/access-control/me/permissions
 *
 * @returns AccessMatrix or null if fetch fails
 */
export const fetchUserPermissions = async (): Promise<AccessMatrix | null> => {
  try {
    console.log('🔑 Fetching user permissions from API...');
    const response = await api.get<AccessMatrix>('/access-control/me/permissions');
    console.log('✅ Permissions fetched successfully:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ Failed to fetch user permissions:', error);
    return null;
  }
};
